import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=320bbf1e&scoped=true&"
var script = {}
import style0 from "./Modal.vue?vue&type=style&index=0&id=320bbf1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320bbf1e",
  null
  
)

export default component.exports